import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { PersonalDetailsDispatcher } from "./Variable";

export interface PersonalDetailsStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class PersonalDetailsStatic extends BaseStore<PersonalDetailsStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(PersonalDetailsDispatcher, (actionData) => this.onPersonalDetailsStoreResponse(actionData));
    }

    public getLastResult(): PersonalDetailsStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): PersonalDetailsStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onPersonalDetailsStoreResponse(actionData): void {
        // debugger;
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}